import _ from 'underscore';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SearchBox } from '@bingads-webui-react/search-box-control';
import { Grid, Col, Row } from '@bingads-webui-react/primitive';
import Item from './item';
import ButtonAddRemove from './button-add-remove';

export default class SourceListBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      searchValue: null,
    };
  }

  onSearch = (query) => {
    this.setState({
      searchValue: query,
    });
  };

  onQueryChange = (query) => {
    this.setState({
      searchValue: null,
      query,
    });
  };

  updateOne = (item) => {
    this.props.onChange(true, this.props.category, [item]);
  }

  updateMany = (items) => {
    this.props.onChange(true, this.props.category, items);
  }

  render() {
    const list = this.props.data.data.items;

    // using indexof instead of includes since later one is not supported in IE
    const result = (this.state.searchValue ? list.filter(item =>
      item.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) > -1) : list);

    // TODO: pass in render function to support custom render template
    return (
      <Grid fluid className={`source-list-box ${this.props.className}`}>
        <Row>
          <Col sm={12}>
            <Row>
              <Col sm={12}>
                <SearchBox
                  onQueryChange={this.onQueryChange}
                  onSearch={this.onSearch}
                  value={this.state.query}
                  classes={this.props.searchBoxClasses}
                  placeholder={this.props.i18n.getString('DoubleListBox_SearchBoxPlaceholder')}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <ButtonAddRemove className="" onClick={() => this.updateMany(result)} add i18n={this.props.i18n} />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                {result.map(item =>
                  (<Item
                    key={item}
                    value={item}
                    selected={false}
                    disabled={
                      _.contains(this.props.data.data.selected, item) ||
                      _.contains(this.props.data.data.disabled, item)
                    }
                    onChange={() => this.updateOne(item)}
                    i18n={this.props.i18n}
                  />))
                }
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    );
  }
}

SourceListBox.propTypes = {
  category: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    data: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.string),
      selected: PropTypes.arrayOf(PropTypes.string),
      disabled: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
  }).isRequired,
  className: PropTypes.string.isRequired,
  /**
   * customized search box classes
   */
  searchBoxClasses: PropTypes.shape({
    input: PropTypes.string,
    icon: PropTypes.string,
    inputGroup: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
